// extracted by mini-css-extract-plugin
export default {"wrapper":"AddInventory_wrapper__w+F0B"};